import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Badge,
} from 'reactstrap';
import { SidebarProps } from '../../shared/prop-types/ReducerProps';
import DataTable from '../../shared/components/DataTable';
import {
  fetchExams,
  deleteExam,
  stampExam,
  downloadAcademicStatusStudent,
  fetchFormDatas,
} from '../../redux/actions/examActions';
import Confirm from '../../shared/components/Confirm';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import {
  dateDDMMYYHHMMFormat,
} from '../../helpers/dateFormat';
import {
  getCurrentUser,
  tableFilters,
} from '../../helpers/storage';
import { Roles } from '../../constants/enums';

const examsTableStorage = tableFilters('tblExams');


class ExamsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);

    const persistedData = examsTableStorage.get();
    const persistedFilters = persistedData.filters || {};
    const defaultFilters = {
      estado: { value: null, label: '-' },
      periodo: { value: null, label: '-' },
      periodoLectivo: { value: null, label: '-' },
    };

    this.state = {
      hasFiltered: Boolean(persistedData.hasFiltered),
      page: persistedData.page || 1,
      pageSize: persistedData.pageSize || 25,
      totalItemsCount: 0,
      filters: {
        ...persistedFilters,
        estado: persistedFilters.estado !== undefined ? persistedFilters.estado : defaultFilters.estado,
        periodo: persistedFilters.periodo !== undefined ? persistedFilters.periodo : defaultFilters.periodo,
        periodoLectivo: persistedFilters.periodoLectivo !== undefined
          ? persistedFilters.periodoLectivo
          : defaultFilters.periodoLectivo,
      },
      loading: true,
      items: [],
      currentUser: getCurrentUser(),
      estadoExamen: { value: null, label: '-' },
      periodosExamen: { value: null, label: '-' },
      periodosLectivos: { value: null, label: '-' },
    };

    const replacements = {
      Primer: '1º',
      Segundo: '2º',
    };

    this.columns = () => [
      {
        key: 'id',
        name: '#',
        search: false,
      },
      {
        key: 'profesor',
        name: 'Profesor',
        search: true,
        visible: false,
      },
      {
        key: 'alumno',
        name: 'Alumno',
        search: true,
        visible: false,
      },
      {
        key: 'documento',
        name: 'Nº Documento',
        search: true,
        visible: false,
      },
      {
        key: 'notasObservaciones',
        name: 'Notas / Obs.',
        search: true,
        visible: false,
      },
      {
        key: 'fecha',
        name: 'Fecha',
        search: false,
        type: 'date',
        width: '130px',
        format: row => dateDDMMYYHHMMFormat(row.fecha),
      },
      {
        orderFilter: 0,
        key: 'materia',
        name: 'Materia',
        className: 'text-left',
        search: true,
        format: ({
          id,
          materia,
          fecha,
          estado,
        }) => (
          <span style={{ display: 'flex', justifyContent: 'start', fontSize: '1rem' }}>
            {
              <button type="button" className="action-button" tabIndex="-1">
                <h4>
                  <Badge
                    id={`badge-${id}`}
                    color={this.getSubjectColor({
                      fecha,
                      estado: estado.value,
                    })}
                  >
                    {materia}
                  </Badge>
                </h4>

              </button>
            }
          </span>
        ),
      },
      {
        key: 'periodo',
        name: 'Periodo',
        search: true,
        type: 'select',
        searchProps: {
          options: this.getPeriodosExamen,
          isMulti: false,
        },
        className: 'text-center',
      },
      {
        orderFilter: 1,
        key: 'periodoLectivo',
        name: 'Periodo Lectivo',
        search: true,
        type: 'select',
        searchProps: {
          options: this.getPeriodosLectivo,
          isMulti: false,
        },
        className: 'text-center',
        format: ({ periodoLectivo }) => periodoLectivo.replace(/^[^:]+: /, '').replace(/Primer|Segundo/, match => replacements[match]),
      },
      {
        key: 'profesor',
        name: 'Profesor',
        search: false,
      },
      {
        key: 'cantidadInscriptos',
        name: 'Inscriptos',
        search: false,
        className: 'text-center',
        format: ({ id, cantidadInscriptos }) => (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            {
              <button type="button" className="action-button" tabIndex="-1">
                <h5>
                  <Badge id={`badge-${id}`} color={cantidadInscriptos ? 'info' : 'secondary'}>
                    {`${cantidadInscriptos}`.padStart(2, ' ')}
                  </Badge>
                </h5>

              </button>
            }
          </span>
        ),
      },
      {
        key: 'cantidadReclamosPendientes',
        name: 'Revisiones',
        search: false,
        className: 'text-center',
        format: ({ id, cantidadReclamosPendientes }) => (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            {
              <button type="button" className="action-button" tabIndex="-1">
                <h5>
                  <Badge id={`badge-review-${id}`} color={cantidadReclamosPendientes ? 'warning' : 'secondary'}>
                    {`${cantidadReclamosPendientes}`.padStart(2, ' ')}
                  </Badge>
                </h5>

              </button>
            }
          </span>
        ),
      },
      {
        key: 'estado',
        name: 'Estado',
        search: true,
        type: 'select',
        searchProps: {
          options: this.getStates,
          isMulti: false,
        },
        className: 'text-center',
        format: ({ id, estado, fecha }) => (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            {
              <button type="button" className="action-button" tabIndex="-1">
                <h5>
                  <Badge
                    id={`badge-${id}`}
                    color={this.getSubjectColor({
                      fecha,
                      estado: estado.value,
                    })}
                  >
                    {estado.label}
                  </Badge>
                </h5>

              </button>
            }
          </span>
        ),
      },
      {
        key: 'modificado',
        name: 'Modificado',
        search: false,
        type: 'date',
        format: row => dateDDMMYYHHMMFormat(row.modificado),
      },
      {
        key: 'actions',
        name: 'Accion',
        width: '90px',
      },
    ];

    this.actions = (row, addButton) => {
      const disabled = [0, 3].includes(row.estado.value) ? '' : 'disabled';
      const showEdit = addButton ? 'edit' : 'check-square-o';
      const titleEdit = addButton ? 'Editar' : 'Editar nota';


      const actions = [
        {
          key: disabled ? 'eye' : 'edit',
          icon: (
            <span
              className={`fa fa-${disabled ? 'eye' : showEdit}`}
              title={`${disabled ? 'Ver' : titleEdit} examen`}
            />
          ),
          callback: ![0, 1, 3, 4].includes(row.estado.value) ? null : (exam) => {
            if ([0, 1, 3, 4].includes(exam.estado.value)) {
              this.editExam(exam);
            }
          },
        },
        {
          key: disabled || !addButton ? '' : 'stump',
          visible: false,
          icon: <span
            className="fa fa-lock"
            style={{ fontSize: '1rem' }}
            title="Sellar examen"
          />,
          callback: disabled ? null : (exam) => {
            if ([0, 3].includes(exam.estado.value)) {
              this.handleStampExam(exam);
            }
          },
        },
        {
          key: row.estado.value >= 0 && addButton ? 'print' : '',
          visible: false,
          icon: <span className="fa fa-print" title="Imprimir Acta" />,
          callback: (exam) => {
            if (exam.estado.value >= 0) {
              this.handleShowPreviewExam(exam);
            }
          },
        },
        {
          key: disabled || !addButton ? '' : 'delete',
          icon: <span className="fa fa-trash" title="Borrar examen" />,
          callback: disabled ? null : (exam) => {
            if (exam.estado.value === 0) {
              this.handleDeleteExam(exam);
            }
          },
        },
      ];

      return actions.filter(a => a.visible !== false);
    };
  }

  componentDidMount() {
    const {
      page, pageSize, totalItemsCount, hasFiltered, filters,
    } = this.state;

    const state = {
      page,
      pageSize,
      totalItemsCount,
    };

    (async () => {
      await this.fetchDatasList();

      const viewPageAs = this.getViewPageAs();

      // Si es Admin o Funcionario no disparamos la búsqueda automática al montar.
      // Deben aplicar filtros explícitamente.
      if ([Roles.Admin, Roles.Funcionario].includes(viewPageAs)) {
        return;
      }

      if (hasFiltered) {
        await this.updateExamsTable({
          page,
          pageSize,
          filters,
        });
        return;
      }

      await this.updateExamsTable({ ...state });
    })();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      page, pageSize, totalItemsCount, filters,
    } = this.state;
    const state = { filters };

    // Typical usage (don't forget to compare props):
    if (page !== prevState.page) {
      state.page = page;
    }

    if (pageSize !== prevState.pageSize) {
      state.pageSize = pageSize;
    }

    if (totalItemsCount !== prevState.totalItemsCount) {
      state.totalItemsCount = totalItemsCount;
    }
  }

  handleAutoHideChange = (value) => {
    const {
      page, pageSize, hasFiltered, filters,
    } = this.state;
    const newFilters = { ...filters, autoHideSearch: value };

    this.setState({ filters: newFilters });

    examsTableStorage.set({
      page,
      pageSize,
      filters: newFilters,
      hasFiltered,
    });
  }

  fetchDatasList = async (anhoLectivoId = 0) => {
    this.setState({ loading: true });
    await fetchFormDatas(anhoLectivoId, {
      onSuccess: ({
        periodosExamen,
        periodosLectivos,
        estadoExamen,
      }) => {
        const replacements = {
          Primer: '1º',
          Segundo: '2º',
        };
        const pLectivos = periodosLectivos.map((pl) => {
          const formattedLabel = pl.label
            .replace(/^[^:]+: /, '')
            .replace(/Primer|Segundo/, match => replacements[match]);

          return {
            ...pl,
            label: formattedLabel,
          };
        });

        this.setState(prevState => ({
          loading: false,
          periodosExamen,
          periodosLectivos: pLectivos,
          estadoExamen: [
            { value: null, label: '-' },
            ...estadoExamen,
          ],
          filters: {
            ...prevState.filters,
            periodoLectivo: prevState.filters && prevState.filters.periodoLectivo
              ? prevState.filters.periodoLectivo
              : { value: null, label: '-' },
          },
        }));
      },
      onError: () => {
        this.setState({ loading: false });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  updateExamsTable = async ({
    page = 1,
    pageSize = 25,
    filters = {},
  }) => {
    const viewPageAs = this.getViewPageAs();
    const estado = filters.estado || { value: null, label: '-' };
    const periodo = filters.periodo || { value: null, label: '-' };
    const periodoLectivo = filters.periodoLectivo || { value: null, label: '-' };

    const state = {
      page,
      pageSize,
      filters: {
        ...filters,
        viewPageAs,
        estado,
        periodo,
        periodoLectivo,
      },
    };

    this.setState({
      loading: true,
      ...state,
    });

    examsTableStorage.set({
      page,
      pageSize,
      filters: state.filters,
      hasFiltered: true,
    });

    await fetchExams({
      pageInfo: {
        page,
        pageSize,
        filters: {
          ...filters,
          viewPageAs,
          estado: filters.estado || { value: null, label: '-' },
          periodo: filters.periodo || { value: null, label: '-' },
        },
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          hasFiltered: true,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de exámenes');
      },
    });
  }

  handleDeleteExam = (examen) => {
    const {
      materia,
      fecha,
    } = examen;

    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    Confirm({
      title: 'Borrar examen',
      question: `¿Estás seguro que deseas eliminar el examen ${materia} del ${dateFormated}?.`,
      yesLabel: 'Si, Borrar examen',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteExam(examen.id, {
          onSuccess: () => {
            createSuccessMessage('Examen borrado exitosamente');
            const { page, pageSize } = this.state;
            this.updateExamsTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else {
              createErrorMessage('Error al intentar borrar el examen');
            }
          },
        });
      },
    });
  };

  handleStampExam = (examen) => {
    const {
      materia,
      fecha,
      fechaInicioReclamo,
      fechaFinReclamo,
    } = examen;

    if (!fechaInicioReclamo || !fechaFinReclamo) {
      createWarningMessage('Antes de sellar debes configurar Inicio y Fin de solicitud de revisión en el examen.');
      return;
    }

    if (new Date(fechaInicioReclamo) > new Date(fechaFinReclamo)) {
      createWarningMessage('Rango de solicitud de revisión inválido.');
      return;
    }

    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    Confirm({
      title: 'Sellar examen',
      question: `¿Estás seguro que deseas sellar el examen ${materia} del ${dateFormated}?
Una vez sellado ya no será editable.`,
      yesLabel: 'Si, Sellar examen',
      noLabel: 'No, Volver',
      color: 'success',
      onConfirm: () => {
        stampExam(examen.id, examen, {
          onSuccess: () => {
            createSuccessMessage('Examen sellado exitosamente');
            const { page, pageSize } = this.state;
            this.updateExamsTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar sellar el examen');
            }
          },
        });
      },
    });
  };

  handleShowPreviewExam = (examen) => {
    const { history } = this.props;
    const {
      id,
      materia,
      fecha,
      nroActa,
      estado,
    } = examen;

    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    const [materiaName, carreraName] = materia
      .replace('(', '-')
      .replace(')', '')
      .split('-')
      .map(it => it.trim());

    const confirmData = {
      title: `Imprimir Examen ${materiaName} ${carreraName}`,
      noLabel: 'No, Volver',
      color: 'success',
    };

    if (estado.value === 1) {
      const question = `¿Imprimir el acta o planilla de calificaciones del examen ${materia} del ${dateFormated}
        Acta Nº ${nroActa}?`;

      confirmData.question = question;
      confirmData.yesLabel = 'Imprimir Acta';
      confirmData.otherLabel = 'Descargar Acta';

      confirmData.onConfirm = () => {
        history.push(`/pages/exams/show-report/${id}`);
      };
      confirmData.onOther = () => {
        this.setState({ loading: true });
        downloadAcademicStatusStudent({ id: examen.id, materiaName }, {
          onSuccess: () => {
            this.setState({ loading: false });
            createSuccessMessage('Archivo descargado exitosamente');
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar descargar la planilla de calificaciones del examen');
            }
          },
        });
      };
    }

    if (estado.value === 0) {
      const question = `¿Imprimir planilla de calificaciones del examen ${materia} del ${dateFormated}
        Acta Nº ${nroActa}?`;

      confirmData.question = question;
      confirmData.yesLabel = 'Descargar Acta';
      confirmData.onConfirm = () => {
        this.setState({ loading: true });
        downloadAcademicStatusStudent({ id: examen.id, materiaName }, {
          onSuccess: () => {
            this.setState({ loading: false });
            createSuccessMessage('Archivo descargado exitosamente');
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar descargar la planilla de calificaciones del examen');
            }
          },
        });
      };
    }

    Confirm(confirmData);
  };

  editExam = (exam) => {
    const { history } = this.props;
    history.push(`/pages/exams/edit/${exam.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateExamsTable({ page, pageSize, filters });
    }
  };

  hasAnySearchFilter = (values = {}) => {
    const textFields = ['materia', 'profesor', 'alumno', 'documento', 'notasObservaciones'];
    const selectFields = ['estado', 'periodo', 'periodoLectivo'];

    const hasTextFilter = textFields.some(field => (values[field] || '').toString().trim().length > 0);
    if (hasTextFilter) {
      return true;
    }

    return selectFields.some((field) => {
      const current = values[field];
      if (!current) {
        return false;
      }

      if (Array.isArray(current)) {
        return current.length > 0;
      }

      return current.value !== null && current.value !== undefined && current.value !== '';
    });
  };

  onDataTableSubmit = (values) => {
    if (!values) {
      return;
    }

    const { pageSize } = this.state;
    const viewPageAs = this.getViewPageAs();
    const requiresFilter = [Roles.Admin, Roles.Funcionario].includes(viewPageAs);
    console.log({
      requiresFilter,
      values,
    });
    if (requiresFilter && !this.hasAnySearchFilter(values)) {
      createWarningMessage('Para buscar exámenes, debes ingresar al menos un filtro.');
      return;
    }

    this.updateExamsTable({ page: 1, pageSize, filters: values });
  };

  onDataTableClearFilters = () => {
    const { pageSize, filters } = this.state;
    const { autoHideSearch } = filters;
    const viewPageAs = this.getViewPageAs();
    const requiresFilter = [Roles.Admin, Roles.Funcionario].includes(viewPageAs);

    const clearedFilters = {
      estado: null,
      periodo: null,
      periodoLectivo: null,
      autoHideSearch,
    };

    if (requiresFilter) {
      this.setState({
        hasFiltered: false,
        items: [],
        totalItemsCount: 0,
        page: 1,
        pageSize,
        filters: clearedFilters,
      });

      examsTableStorage.set({
        page: 1,
        pageSize,
        filters: clearedFilters,
        hasFiltered: false,
      });

      return;
    }

    this.updateExamsTable({
      page: 1,
      pageSize,
      filters: clearedFilters,
    });
  };

  getGridActions = (key, row) => {
    if (key !== 'actions') {
      return undefined;
    }

    const { currentUser } = this.state;

    const addButton = currentUser.esAdmin || currentUser.esFuncionario;

    const actions = {
      actions: this.actions(row, addButton).filter(a => a.key),
    };

    return actions[key];
  }

  getSubjectColor = ({ fecha, estado }) => {
    if (estado === 1) {
      return 'success';
    }

    if (estado === 3) {
      return 'danger';
    }

    if (estado === 4) {
      return 'warning';
    }

    if (new Date(fecha) > new Date()) {
      return 'info';
    }

    return 'secondary';
  };

  getLabelEstados = () => (
    <Row dir="ltr" style={{ marginBottom: '1rem' }}>
      <Col sm={12}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <h4 style={{ textAlign: 'end' }}>Estados:</h4>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="secondary"
            pill
          >
            Activo expirado
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="info"
            pill
          >
            Activo
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="success"
            pill
          >
            Sellado
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="danger"
            pill
          >
            Inconsistencia de datos
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="warning"
            pill
          >
            Confirmar Notas
          </Badge>
        </div>
      </Col>
    </Row>
  );

  getStates = () => {
    const { estadoExamen } = this.state;
    return estadoExamen;
  };

  getPeriodosExamen = () => {
    const { periodosExamen } = this.state;
    return periodosExamen;
  };

  getPeriodosLectivo = () => {
    const { periodosLectivos } = this.state;
    return periodosLectivos;
  };

  getViewPageAs = () => {
    const { sidebar: { viewPageAs } } = this.props;
    return viewPageAs;
  }

  getTitle = () => {
    const title = <span style={{ marginRight: '20rem' }}>Listado de todos los exámenes</span>;

    const viewPageAs = this.getViewPageAs();
    if (![Roles.Admin, Roles.Funcionario].includes(viewPageAs)) {
      return title;
    }

    return (
      <div>
        {title}
        <Badge color="warning" style={{ fontSize: '14px' }}>
          Para ver los exámenes, primero seleccione los filtros de búsqueda.
        </Badge>
      </div>
    );
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      currentUser,
    } = this.state;

    const addButton = currentUser.esAdmin || currentUser.esFuncionario;

    return (
      <Container>
        {addButton ? (
          <Row>
            <Col md={12}>
              <h3 className="page-title">Lista de ex&aacute;menes</h3>
              <div className="card__title">
                <Link className="btn btn-primary" to="/pages/exams/new">
                  <i className="fa fa-plus" /> Agregar nuevo examen
                </Link>
              </div>
            </Col>
          </Row>
        ) : null
        }
        {this.getLabelEstados()}
        <Row>
          {
            loading
              ? <LoadingSpinner />
              : (
                <DataTable
                  key="tblExams"
                  title={this.getTitle()}
                  columns={this.columns()}
                  items={items}
                  onChangePage={this.onChangePage}
                  totalItemsCount={totalItemsCount}
                  onSubmit={this.onDataTableSubmit}
                  onClearFilters={this.onDataTableClearFilters}
                  getGridActions={(key, row) => this.getGridActions(key, row)}
                  itemsToShow={items.length}
                  page={page}
                  pageSize={pageSize}
                  autoHideSearch={filters.autoHideSearch}
                  onAutoHideChange={this.handleAutoHideChange}
                  initialValues={filters}
                  enableReinitialize

                  filtersLabelsApplied={filters.filtersLabelsApplied}
                  onFiltersLabelsApplied={this.handleFiltersLabelsApplied}
                />
              )
          }
        </Row>
      </Container>
    );
  }
}

ExamsContainer.propTypes = {
  sidebar: SidebarProps.isRequired,
};

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(ExamsContainer));
